var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgQuestionCircleIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 8,
    height: 8,
    viewBox: "0 0 8 8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "#878890",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M4 0C1.792 0 0 1.792 0 4s1.792 4 4 4 4-1.792 4-4-1.792-4-4-4zm.2 6.8h-.4c-.11 0-.2-.09-.2-.2v-.4c0-.11.09-.2.2-.2h.4c.11 0 .2.09.2.2v.4c0 .11-.09.2-.2.2zm1.028-3.1l-.36.368C4.58 4.36 4.4 4.6 4.4 5.2h-.8V5c0-.44.18-.84.468-1.132l.496-.504c.183-.178.274-.44.221-.721-.054-.287-.275-.531-.555-.61-.443-.126-.855.127-.987.508-.051.149-.176.259-.333.259h-.116c-.233 0-.395-.226-.33-.449.171-.589.672-1.037 1.29-1.132.61-.094 1.187.22 1.549.72.472.652.333 1.353-.075 1.761z",
    transform: "translate(-466 -476) translate(466 476)"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionCircleIcon);
export default __webpack_public_path__ + "static/media/question-circle-icon.62819986.svg";
export { ForwardRef as ReactComponent };